import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FiltersTypes } from "@common/types/filters/general";
import { categoryContract } from "@common/contracts/category.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const categoryContractClient = getBackendAPIClient(categoryContract);

export function useCategoryStatistics(
    filters: Pick<FiltersTypes, "entityIds" | "start" | "end">,
) {
    const { workspaceId } = useScope();

    if (!workspaceId) {
        throw new Error("No active workspace");
    }

    return useQuery({
        queryKey: ["categoryStatistics", filters],
        queryFn: () =>
            categoryContractClient.getCategoryStatistics({
                query: {
                    entityIds: filters.entityIds,
                    start: filters.start,
                    end: filters.end,
                },
                params: { workspaceId },
            }),
        placeholderData: keepPreviousData,
    });
}
